import { FIX_FIRST_IMPACT } from "./FIX_FIRST_IMPACT";
import type { Finding } from "./Finding";

// Находка достаточно важна, чтобы красить секцию и попадать в «Главное». Без важности
// (старый разбор, `rated` — false) важна любая находка, как раньше.
export const isImportant = (finding: Finding, rated: boolean): boolean =>
  !rated || finding.impact >= FIX_FIRST_IMPACT;
